import datepickerFactory from 'jquery-datepicker';
import datepickerSKFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-sk';
import FormValidation from "../../Validation/FormValidation";

datepickerFactory($);
datepickerSKFactory($);

const DateInput = {

    bind(form) {
        this.input = '.input.date input[type="text"]';
        form.find(this.input).on('change', (evt) => {
            FormValidation.setValid($(evt.currentTarget), this.isValid($(evt.currentTarget)));
        });

        form.find(this.input).on('click', (evt) => {
            evt.preventDefault();
        })

        const today = new Date()
        const tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1)

        $.datepicker.setDefaults($.datepicker.regional[$("html").attr("lang")]);

        $(this.input).each(function() {
			$(this).datepicker({
				dateFormat: "dd.mm.yy",
				minDate: new Date(),
				beforeShowDay: (date) => {
					const $datepicker = $(this).closest('.date');
					const daysAttr = $datepicker.attr('days');
					const fromAttr = $datepicker.attr('from');
					const toAttr = $datepicker.attr('to');

					const days = daysAttr ? daysAttr.split(',').map(Number) : null;

					const fromDate = fromAttr ? $.datepicker.parseDate('dd.mm.yy', fromAttr) : null;
					const toDate = toAttr ? $.datepicker.parseDate('dd.mm.yy', toAttr) : null;

					const day = date.getDay();

					const afterFrom = fromDate ? date >= fromDate : true;
					const beforeTo = toDate ? date <= toDate : true;

					const validDay = days ? days.includes(day) : true;

					return [afterFrom && beforeTo && validDay];
				}
			});
		});
    },

    check(form) {
        let ok = true;
        form.find(this.input).each((i, el) => {
            ok &= this.isValid($(el));
            FormValidation.setValid($(el), this.isValid($(el)), true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');

        if (isRequired) return input.val().length === 10
        else return true;

    },
}

export default DateInput;
